import React from 'react';
import { useSelector } from 'react-redux';

import { selectPerPayPeriodText } from 'enrollment/services';
import { getPremiumStyled, RETURN_VALUE_ONLY } from 'enrollment/utils';

interface CategoryHeaderProps {
  category: string;
  cost: number;
}
export const CategoryHeader: React.FC<CategoryHeaderProps> = ({
  category,
  cost,
}) => {
  const perPayText = useSelector(selectPerPayPeriodText);
  const formattedCost = getPremiumStyled({
    premium: String(cost),
    valueOnly: RETURN_VALUE_ONLY,
  });

  return (
    <div className="category-header">
      <h2>{category}</h2>
      <div className="cost">
        {formattedCost}
        <div className="d-md-none per-pay">{`${perPayText}`}</div>
      </div>
    </div>
  );
};
